











































































































import { defineComponent, reactive, watch, toRefs, onBeforeMount, computed } from '@vue/composition-api';
import { Schedule, Session } from '@/helpers/types';
import { useSession } from '@/composition-functions/useSession';
import { useStore } from '@/utils/use-store';

import CommonTable from '@/components/CommonTable.vue';
import ItemSelector from '@/components/ItemSelector.vue';

export default defineComponent({
  name: 'ScheduleEditForm',

  components: {
    CommonTable,
    ItemSelector,
  },

  props: {
    open: {
      type: Boolean,
      default: () => false,
    },
    schedule: {
      type: Object,
      default: () => {},
    },
    userList: {
      type: Array,
      default: () => {},
    }
  },

  setup(props, { emit }) {
    const state = reactive({
      selectedSession: null,
      selectedUser: null,
      tempSchedule: {
        sessions: [] as Session[],
      } as Schedule,
      usersSelectorDialog: false,
      sessionsSelectorDialog: false,
    });
    const store = useStore();
    const { accessToken: token } = store.state.user;

    const { sessionList, fetchSessions, } = useSession();

    watch(() => props.schedule, (value: any) => {
      if (Object.keys(value)) {
        state.tempSchedule = Object.assign({}, value);
      } else {
        state.tempSchedule = {
          sessions: [] as Session[],
          users: [] as any[],
        } as Schedule;
      }
    });

    /**
     * Reset form
     * */
    function reset() {}

    /**
     * Handler for close event
     * */
    function closeEventHandler() {
      emit('close');
      reset();
    }

    /**
     * Handler for submit event
     * */
    function submitEventHandler() {
      emit('edit-schedule', { users: state.tempSchedule.users.map(i => i.id), sessions: state.tempSchedule.sessions.map(i => i.id) });
    }

    /**
     * Handler for select users event
     * @param {any[]} payload
     * */
    function selectUsersEventHandler(payload: any[]) {
      state.tempSchedule.users = [...state.tempSchedule.users, ...(props.userList as any []).filter(us => payload.includes(us.id))];
    }

    /**
     * Handler for select users event
     * @param {any[]} payload
     * */
    function selectSessionsEventHandler(payload: any[]) {
      state.tempSchedule.sessions = [...state.tempSchedule.sessions, ...sessionList.value.filter(us => payload.includes(us.id))];
    }

    /**
     * Handler for delete session item event
     * @param {number} id
     * */
    function deleteSessionEventHandler(id: number) {
      state.tempSchedule.sessions = state.tempSchedule.sessions.filter(s => s.id !== id);
    }

    /**
     * Handler for delete user item event
     * @param {number} id
     * */
    function deleteUserEventHandler(id: number) {
      state.tempSchedule.users = state.tempSchedule.users.filter(s => s.id !== id);
    }

    onBeforeMount(async () => {
      await fetchSessions(token);
    });

    return {
      ...toRefs(state),
      sessionList,
      closeEventHandler,
      submitEventHandler,
      selectUsersEventHandler,
      selectSessionsEventHandler,
      deleteSessionEventHandler,
      deleteUserEventHandler,
    };
  }
});
